import React from "react";
import { BrowserRouter as Router, Switch, Route, Redirect } from "react-router-dom";
import { AuthProvider } from "../contexts/AuthContext";
import WithNavbar from "./extras/PrivateRouteWithNavbar";
import Login from "./account/Login"
import ForgotPassword from "./account/ForgotPassword"
import Profile from "./account/Profile";
import NotFound from "./extras/NotFound";
import Products from "./routes/Products";
import Customers from "./routes/Customers";
import Sellers from "./routes/Sellers";
import Resupplies from "./routes/Resupplies.js";
import Sales from "./routes/Sales";

export default function App() {

    return (
      <Router>
        <AuthProvider>
          <Switch>
              <Route path="/login" component={Login} />
              <Route path="/forgot-password" component={ForgotPassword} />
              <Route exact path="/"><Redirect to="/products"/></Route>
              <WithNavbar path="/profile" component={Profile} />
              <Route path="/products" component={Products} />
              <Route path="/customers" component={Customers} />
              <Route path="/sellers" component={Sellers} />
              <Route path="/resupplies" component={Resupplies} />
              <Route path='/sales' component={Sales} />
              <Route path="*" component={NotFound} />
          </Switch>
        </AuthProvider>
      </Router>
    )
  }